import axios from "axios";
import { API_BASE } from './config';
import { NotificationService } from './notifications';

// Initialize notification bus once in the app lifecycle (safe to call multiple times)
NotificationService.init();

export const api = axios.create({
  baseURL: API_BASE,
  // Cookies are not required (we use Bearer tokens). Disabling credentials avoids CORS restrictions.
  withCredentials: false,
});

// Attach notification hooks
NotificationService.attachAxios(api);

// デバッグ表示（開発環境のみ）
if (typeof window !== "undefined" && process.env.NODE_ENV === 'development') {
  console.log("API_BASE configured:", API_BASE);
}

// 認証トークン付きリクエスト用のヘルパー
export const apiWithAuth = (token) => {
  // Backward compatibility: allow legacy 'access_token' and admin tokens
  const authToken =
    token ||
    localStorage.getItem('token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('admin_token');

  const instance = axios.create({
    baseURL: API_BASE,
    // Use Authorization header instead of cookies
    withCredentials: false,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
    },
  });

  // Optional DEMO mode: append ?demo=1 to GET /applications when enabled
  try {
    const demoEnabled = (process.env.REACT_APP_DEMO_MODE || '').toString().toLowerCase();
    if (demoEnabled === '1' || demoEnabled === 'true' || demoEnabled === 'on') {
      instance.interceptors.request.use((config) => {
        try {
          const isGet = (config.method || 'get').toLowerCase() === 'get';
          // Only target the applications listing endpoint; keep others intact
          const urlPath = (config.url || '').split('?')[0];
          if (isGet && (urlPath === '/applications' || urlPath.endsWith('/applications'))) {
            const hasQuery = (config.url || '').includes('?');
            const joiner = hasQuery ? '&' : '?';
            config.url = `${config.url}${joiner}demo=1`;
          }
        } catch { }
        return config;
      });
    }
  } catch { }

  return instance;
};

// Attachors for instances created via apiWithAuth are handled by caller if needed.
// For common usage, we can provide a helper to attach after creation:
export const attachNotifyTo = (axiosInstance) => NotificationService.attachAxios(axiosInstance);

export { API_BASE };

export default api;
